import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { NavController, App, ToastController } from 'ionic-angular';
import { HomePage } from '../../pages/home/home';
import { WaitingPage } from '../../pages/waiting/waiting';
import { ChooseOpponentPage } from '../../pages/choose-opponent/choose-opponent';
import { SelectQuestionPage } from '../../pages/select-question/select-question';
import { SelectAnswerPage } from '../../pages/select-answer/select-answer';
import { ResponseResultPage } from '../../pages/response-result/response-result';
// import { QuizResultPage } from '../../pages/quiz-result/quiz-result';



import 'rxjs/add/operator/map'; 

@Injectable()
export class DataProvider {
	socket: any;
	isPlayer1: Boolean;
	$: any;
	private navCtrl: NavController;
	constructor(public http: Http, private app:App, public toastCtrl: ToastController,) {
		this.$ = {};
		this.isPlayer1 = false;
		var _ = this.$;
		console.log('Hello DataProvider Provider');
		this.socket = require('socket.io-client')('https://game.buildmyvocab.com/');
		//this.socket = require('socket.io-client')('http://localhost:3000');
		_ = {
			gameCode: '',
			deckCode: '',
			player1: {
				id: '',
				name: '',
				points: 0,
				currentState: {}
			},
			player2: {
				id: '',
				name: '',
				points: 0,
				currentState: {}
			},
			questionsCount: 0
		};
		this.navCtrl = app.getActiveNav();
		this.initSocketEvents()
		
	}

	startGame(name, deckCode) {
		this.socket.emit('start_game', { name, deckCode});
	}

	joinGame(name, gameCode) {
		this.socket.emit('join_game', { name, gameCode});
	}

	findRandomOpponent(name, gameCode) {
		this.socket.emit('find_player', { name, gameCode});
		this.navCtrl.setRoot(WaitingPage, {message: 'Searching for Opponent', hideExit: true});
	}

	selectQuestionCard(title, category) {
		this.socket.emit('select_question_card', { isPlayer1: this.isPlayer1, title, category});
	}

	submitAnswer(answer) {
		this.socket.emit('submit_answer', { isPlayer1: this.isPlayer1, answer });
	}

	initSocketEvents() {
		var _ = this.$;
		this.socket.on('disconnect', () => {
			this.navCtrl.setRoot(HomePage);
		});

		this.socket.on('message', (resp) => {
			_ = resp.state;
			var scoreBoard;
			var opponentsName = this.isPlayer1 ? _.player2.name : _.player1.name;
			switch(resp.code) {
				case 'start_game_sucess': 
					this.isPlayer1 = true;
					this.navCtrl.setRoot(ChooseOpponentPage, {gameCode: resp.state.gameCode, dataProvider: this, name: _.player1.name});
					break;
				case 'join_game_sucess': 
					this.isPlayer1 = false;
					this.navCtrl.setRoot(WaitingPage, {message: 'Playing against ' + _.player1.name, hideExit: true});
					setTimeout(() => this.navCtrl.setRoot(SelectQuestionPage, {cards: resp.cards, category: resp.category, dataProvider: this}), 5000);
					break;
				case 'player_2_joined': 
					this.navCtrl.setRoot(WaitingPage, {message: 'Playing against ' + _.player2.name, hideExit: true});
					setTimeout(() => this.navCtrl.setRoot(SelectQuestionPage, {cards: resp.cards, category: resp.category, dataProvider: this}), 5000);
					break;
				case 'invalid_game_code': 
					 let toast = this.toastCtrl.create({
				        message: 'Invalid Invitation Code',
				        duration: 3000
				      });
				      toast.present();
					break;
				case 'select_question_card_success': 
					this.navCtrl.setRoot(WaitingPage, {message: 'Waiting for ' + opponentsName, hideExit: true});
					break;
				case 'ask_question':
					if (this.isPlayer1) {
						this.navCtrl.setRoot(SelectAnswerPage, { question: _.player1.currentState.question, dataProvider: this });
					} else {
						this.navCtrl.setRoot(SelectAnswerPage, { question: _.player2.currentState.question, dataProvider: this });
					}
					break;
				case 'show_answer_response':
					var myState = (this.isPlayer1) ? _.player1.currentState : _.player2.currentState;
					var opponentState = (this.isPlayer1) ? _.player2.currentState : _.player1.currentState;
					var isMyAnswerValid = myState.isValid;
					var validCard = myState.validCard;
					var isOpponentsAnswerValid = opponentState.isValid;
					scoreBoard = [{name: _.player1.name, points: _.player1.points},
									  {name: _.player2.name, points: _.player2.points}];
					var cards = myState.cards;
					var category = myState.category;
					var questionsCount = _.questionsCount;

					this.navCtrl.setRoot(ResponseResultPage, { opponentsName, isMyAnswerValid, validCard, isOpponentsAnswerValid, scoreBoard, cards, category, questionsCount, dataProvider: this });
					break;
				case 'submit_answer_success': 
					this.navCtrl.setRoot(WaitingPage, {message: 'Waiting for ' + opponentsName, hideExit: true});
					break;
				case 'game_over': 
					// var result = resp.result;
					// scoreBoard = [{name: _.player1.name, points: _.player1.points},
					// 				  {name: _.player2.name, points: _.player2.points}];
					// this.navCtrl.setRoot(QuizResultPage, {result, scoreBoard});
					break;
				case 'player_disconnected':
					this.navCtrl.setRoot(WaitingPage, {message: opponentsName + ' left the Game.', hideExit: false});
					break;
			}
		}); 
	}



}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts